import { PositionData } from '../types/mapUtils.type'

export const project = (lat: number, lng: number) => {
  const TILE_SIZE = 256

  const siny = Math.sin((lat * Math.PI) / 180)
  const boundedSiny = Math.min(Math.max(siny, -0.9999), 0.9999)

  return {
    x: ((lng + 180) / 360) * TILE_SIZE,
    y: (0.5 - Math.log((1 + boundedSiny) / (1 - boundedSiny)) / (4 * Math.PI)) * TILE_SIZE,
  }
}

export const unproject = (x: number, y: number) => {
  const TILE_SIZE = 256

  const lng = (x / TILE_SIZE) * 360 - 180
  const n = Math.PI - (2 * Math.PI * y) / TILE_SIZE
  const lat = (180 / Math.PI) * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n)))

  return { lat, lng }
}

export const getProjectedBounds = ({
  center,
  zoom,
  mapWidth,
  mapHeight,
}: {
  center: PositionData
  zoom: number
  mapWidth: number
  mapHeight: number
}) => {
  const scale = Math.pow(2, zoom)
  const worldCoordinateCenter = project(center.lat, center.lng)

  const pixelOffset = {
    x: mapWidth / 2 / scale,
    y: mapHeight / 2 / scale,
  }

  const topLeftWorld = {
    x: worldCoordinateCenter.x - pixelOffset.x,
    y: worldCoordinateCenter.y - pixelOffset.y,
  }

  const bottomRightWorld = {
    x: worldCoordinateCenter.x + pixelOffset.x,
    y: worldCoordinateCenter.y + pixelOffset.y,
  }

  const topLeftLatLng = unproject(topLeftWorld.x, topLeftWorld.y)
  const bottomRightLatLng = unproject(bottomRightWorld.x, bottomRightWorld.y)

  return {
    topLeft: topLeftLatLng,
    bottomRight: bottomRightLatLng,
  }
}

export const isPositionVisible = (map: google.maps.Map, position: PositionData) => {
  const bounds = map.getBounds()
  if (!bounds) return false

  const latLng = new google.maps.LatLng(position.lat, position.lng)
  return bounds.contains(latLng)
}

export const getCenterFromBounds = (topLeft: PositionData, bottomRight: PositionData) => {
  const centerLat = (topLeft.lat + bottomRight.lat) / 2
  let centerLng = (topLeft.lng + bottomRight.lng) / 2

  if (topLeft.lng > bottomRight.lng) {
    centerLng = ((topLeft.lng + (bottomRight.lng + 360)) / 2) % 360

    if (centerLng > 180) {
      centerLng -= 360
    }
  }

  return { lat: centerLat, lng: centerLng }
}
